
import React from "react";
import { motion } from "framer-motion";

export function Header() {
  return (
    <motion.header
      className="fixed top-0 left-0 right-0 z-50 bg-[#1a1a2e]/95 backdrop-blur-sm border-b border-[#ff3366]/20"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="/img/axis-logo.gif" 
              alt="Hormonal Axis" 
              className="w-12 h-12 md:w-16 md:h-16"
            />
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-[#ff3366]">
                Hormonal Axis
              </h1>
              <p className="text-sm text-[#ff3366]/60">
                Calculadora de Eixo Hormonal
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
